import React, { useEffect} from 'react';
import 'assets/styles/ads.css'
import {WideContainer} from 'components/mui/containers/PxftContainer';
import GostoryHeader from 'components/gostoryAds/gostoryHeader';
import GostoryArticle from 'components/gostoryAds/gostoryArticle';

const GostoryAds=()=>{
    useEffect(()=>{
        window.scrollTo(0, 0);
    },[])
    
    return (
        <>
        <WideContainer>
            <GostoryHeader/>
            <GostoryArticle/>
        </WideContainer>
        </>

);
}

export default GostoryAds;